import { Action } from 'redux';
import { CarriersMap } from '../types';

export const CARRIERS_LOAD_START = 'carriers/loadStart';
export const CARRIERS_LOAD_SUCCESS = 'carriers/loadSuccess';
export const CARRIERS_LOAD_FAILURE = 'carriers/loadFailure';

export interface CarriersLoadStartAction extends Action {
    type: typeof CARRIERS_LOAD_START;
}

export interface CarriersLoadSuccessAction extends Action {
    type: typeof CARRIERS_LOAD_SUCCESS;
    payload: CarriersMap;
}

export interface CarriersLoadFailureAction extends Action {
    type: typeof CARRIERS_LOAD_FAILURE;
    payload: string;
}

export type CarriersActions = CarriersLoadStartAction | CarriersLoadSuccessAction | CarriersLoadFailureAction;
